import logo from '../assets/Alibaba-Logo.png'
import { Link } from 'react-router-dom'
import './Navbar.css'
import flag from '..//assets/jordan-flag-logo-removebg-preview.png'
import pic1_main from '..//assets/pic1_main.avif'
import pic2_main from '..//assets/pic2_main.avif'
import pic3_main from '..//assets/pic3_main.avif'
import pic4_main from '..//assets/pic4_main.avif'

import pic1_main2 from '..//assets/pic1_main2.avif'
import pic2_main2 from '..//assets/pic2_main2.avif'
import pic3_main2 from '..//assets/pic3_main2.avif'
import pic4_main2 from '..//assets/pic4_main2.avif'
import axios from 'axios';
import { useState,useEffect } from 'react'
const Navbar = () => {
 const [quantity,setQuantity]=useState(0)
const URL = process.env.REACT_APP_URL || 'https://alibaba-store-3.onrender.com';




useEffect(() => {
  const fetchQuantity = async () => {
    try {
      const response = await axios.get(`${URL}/cart/quantity`);
      setQuantity(response.data || 0);
    } catch (err) {
      const msg = err.response?.data?.message || err.message;
      alert(msg);
      // or use a toast notification
    }
  };

  fetchQuantity(); // call the async function

  const handleCartUpdate = () => fetchQuantity();
  window.addEventListener('cartUpdated', handleCartUpdate);

  return () => {
    window.removeEventListener('cartUpdated', handleCartUpdate);
  };
}, []); //

  return (
    <>

      <div className='above_nav '></div>

      <nav className='nb-container '>
        <Link to='/'>
          <section>
            <img className='logo' src={logo} alt="logo" />
          </section>
        </Link>


        <section className='d-flex align-items-center mb-1 flex-grow-1 mx-4'>
          <input placeholder='digital cameras' className='nav-search  rounded-5 p-4  flex-grow-1'>
          </input>

          <button className='search-btn rounded-5'>
            <span className='search-span'>
              <i class="fa-solid fa-magnifying-glass text-white me-2"></i>
              <div className='txt-search  text-white'>search</div>
            </span>

          </button>

        </section>


        <section className='d-flex align-items-center flex-wrap justify-content-center mt-1'>
          <div className='nav-left-1 me-4'>
            <div className='deliver-to'>Deliver to:</div>
            <div className='d-flex align-items-center'>
              <img className='flag' src={flag} alt='pic' />
              <div className='fw-bold'>JO</div>
            </div>
          </div>

          <div className='nav-left-2 me-4 d-flex align-items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="BLACK" className="bi bi-globe me-1" viewBox="0 0 16 16">
              <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
            </svg>
            <div className='deliver-to fw-bold '> English-JOD</div>
          </div>

          <Link to="/Cart" style={{ textDecoration: 'none' }}>
            <div className='nav-left-3 me-4 d-flex align-items-center position-relative'>
               
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="black" className=" bi bi-cart" viewBox="0 0 16 16">
                <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l1.313 7h8.17l1.313-7zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                  
              </svg>
              {quantity<10 && <p className='quantity1 fw-bolder text-dark '>0</p>}
              {quantity>=10 && <p className='quantity fw-bolder text-dark '>{quantity}</p>}
              

            </div>
          </Link>

          <Link to="/SignIn" style={{ textDecoration: 'none' }}>

            <div className='nav-left-4 me-4 d-flex align-items-center'>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="black" className=" bi bi-person" viewBox="0 0 16 16">
                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
              </svg>

              <div className='deliver-to fw-bold '>Sign in</div>

            </div>
          </Link>
          <div className='nav-left-4 me-4 d-flex align-items-center'>
            <div className='nav-left-5 me-4 d-flex align-items-center'>
              <Link to="/SignUp">
                <button className='signup-btn rounded-5 fw-bold'>
                  Sign up
                </button>
              </Link>
            </div>


          </div>


        </section>



      </nav>

      <nav className='nb-container2 d-flex flex-wrap align-items-center align-content-center justify-content-between m-2 border-bottom border-2'>

        <section className='d-flex align-items-center flex-wrap align-content-center justify-content-center'>
          <div className='nb-container2-item p-1 d-flex '>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="me-1  bi bi-list" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
            </svg>
            All categories

          </div>
          <div className='nb-container2-item p-1'>Verified manufacturers</div>
          <div className='nb-container2-item p-1'>Trade Assurance</div>
        </section>

        <section className='d-flex align-items-center flex-wrap align-content-center justify-content-center'>
          <div className='nb-container2-item p-1'>Accio Work</div>

          <div className='nb-container2-item p-1'>Tax exemption</div>
          <div className='nb-container2-item p-1'>Buyer Central</div>
          <div className='nb-container2-item p-1'>App & extension</div>
          <div className='nb-container2-item p-1'>Become a supplier</div>
        </section>

      </nav>

    </>
  )
}

export default Navbar